import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-text",
  "use": "icon-text-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-text\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h16v16H0z\" /><path fill=\"currentColor\" fill-rule=\"nonzero\" d=\"M16 2v12H3v-2h11V4.869L9 8.215 3 4.202V2h13zM5 9v2H0V9h5zm0-3v2H1V6h4zm6.701-2H6.294L9 5.81 11.701 4z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol